import { showQuestionModal } from "../components/modals/QuestionModal";
import { EDITOR_VIEW_NAME, LOADING_VIEW_NAME, NEXT_PROJECT_BUTTON } from "../core/constants";
import { translate } from "../core/i18n";
import { showNextProject } from "../core/project/projectdata";
import { getDomainCfg, setStateVariable } from "../core/state";
import { getViewData, setViewData, showView } from "../core/views";
import { forceEvaluationGreen } from "./executecode";
import { logGamificationEvent } from "./gamification/events";
import { getRedirectUrl, redirectTo } from "./redirect";
import { addPoints, generateResultCode, getMaxPoints } from "./resultcode";
import confetti from 'canvas-confetti';
import { nextQueryWaypoint, unlockQuest } from "./stats";
import { getAppCfg } from "../core/app-cfg";

export const showSuccess = () : void => {
  addPoints(getMaxPoints());
  generateResultCode();
  showSuccessCard();
  logGamificationEvent("ProjectFinished", "Projekt geschafft", "");
  requestShowNextButton();
  forceEvaluationGreen();
}

const requestShowNextButton = () => {
 
  const editorState = getViewData(EDITOR_VIEW_NAME);
  if (editorState.project?.unlocksQuest) {
    unlockQuest(editorState.project.unlocksQuest);
  }
  
  const hasNextProjectOrQuest = editorState.project?.nextProject || editorState.project?.completesQuestStep;
  if (!hasNextProjectOrQuest && !getDomainCfg().viewSettings.features.learndashTrigger) return;

  // Prüfe ob der Next-Button in der Config deaktiviert ist
  if (getDomainCfg().viewSettings.features.showNextButton === false) {
    return;
  }
  
  setStateVariable(NEXT_PROJECT_BUTTON, true);
}

export const triggerLearnDash = () => {
  const lerndashElement : HTMLElement = document.querySelector(getDomainCfg().viewSettings.features.learndashTrigger);
  console.log('trigger next lecture', getDomainCfg().viewSettings.features.learndashTrigger, lerndashElement);
  if (lerndashElement) {
    lerndashElement.click();
    //showView(LOADING_VIEW_NAME);  
  }
}

export const requestNextProject = () => {
  const editorState = getViewData(EDITOR_VIEW_NAME);
  if (getDomainCfg().viewSettings.features.learndashTrigger) {
    triggerLearnDash();
  }

  if (editorState.project?.nextProject) {
    showNextProject(editorState.project.nextProject);
  } else if (editorState.project?.completesQuestStep) {    
    backToQuest(editorState.project.completesQuestStep);
  }
}

export async function backToQuest(questId : string) : Promise<void> {
  await nextQueryWaypoint(questId, getAppCfg().projectId);
  redirectTo(
    getRedirectUrl(getDomainCfg().viewSettings.questView, questId, "quest")
  );
}


function showSuccessCard() {
  
  const editorState = getViewData(EDITOR_VIEW_NAME);
  if (editorState.data?.projectFinished || editorState.cfg?.editorFeatures?.showSuccessModal === false) {
    return;
  }

  console.log('show success card', editorState)
  const exitEditor = () => {
    redirectTo(getRedirectUrl(getDomainCfg().viewSettings.projectsView));
  }

  const opts = {
    okTitle : translate('play-button-title'),
    okColor : "btn-success",
    okIcon : "play",
    secondBtnText : translate('next-button-title'),
    secondColor : "btn-primary",
    secondIcon : "forward"
  }

  const successMessage = '<br><div class="ps-5">' +  editorState.project?.successContent + '</div>'
  const projectSuccess = editorState.project?.successContent ? successMessage: "";
  
  const productSuccessContent = 
  "<div class='text-center'><span class='color-change-2x'><img class='tadaEffectProjectSuccess' src='" + getDomainCfg().product.successImg + "' width='400' height='400'></span></div>";
  const successContent = productSuccessContent + projectSuccess;

  const hasNextProjectOrQuest = editorState.project?.nextProject || editorState.project?.completesQuestStep;
  const showNextButton = getDomainCfg().viewSettings.features.showNextButton !== false;
  if ((hasNextProjectOrQuest || getDomainCfg().viewSettings.features.learndashTrigger !== undefined) && showNextButton) {
    showQuestionModal(translate("editor-success-title"), successContent, requestShowNextButton, () => {}, opts, requestNextProject);
    throwConfetti();
  } else {
    const exitAction = getDomainCfg().viewSettings.features.showExitButton ? exitEditor : undefined;
    showQuestionModal(translate("editor-success-title"), successContent, requestShowNextButton, () => {}, opts, exitAction);
    throwConfetti();
  }

  editorState.data = {
    ...editorState.data,
    projectFinished : true
  }
  setViewData(EDITOR_VIEW_NAME, editorState);
}

function throwConfetti() {  
  confetti({
    particleCount: 150,
    spread: 360,
    zIndex : 30000,
  });
}

